export enum ParticipantsTabs {
  INVITED = 'invited',
  REGISTERED = 'registered',
}
